const initialState = {
    userProps: {
        user: {
            userName: "",
            firstName: "",
            lastName: "",
            fullName: "",
            employeeID: "",
            staffNaturalKey: "",
            role: "",
            roles: [],
            campusID: "",
            campusName: ""
        }
    },
    
}

export default initialState